// extracted by mini-css-extract-plugin
module.exports = {"fields":"AbsenceModal_fields__1Q-u3","footer":"AbsenceModal_footer__3zP_0"};